





























































































































import { PropType, computed, defineComponent, ref } from '@vue/composition-api';

import { IWorkflowState, IWorkflowTransition } from '@/models';
import { ISystemError } from '@/models/error/error.types';

import { setErrorFromAxiosError } from '@/utils/helpers';

// import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';

import { createNamespacedHelpers, useStore } from 'vuex-composition-helpers';
import { IRootState } from '@/store';
import {
  IWorkflowStoreState,
  IWorkflowGetters,
  IWorkflowActions,
  IWorkflowMutations
} from '@/store/workflow';

import DetailOptionsButton from '@/components/common/DetailOptionsButton.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import { useWorkFlow } from '../workflow-canvas/composables';
import { useNodeConnections } from '../workflow-canvas/composables/useNodeConnections';
import { HexToRGB } from '@/utils/colorUtils';
import { AxiosError } from 'axios';

export default defineComponent({
  name: 'WorkflowStateDetailOptionsButton',

  components: {
    ConfirmationDialog,
    DetailOptionsButton
  },

  mixins: [auth],

  props: {
    workflowId: {
      type: Number,
      required: true
    },
    state: {
      type: Object as PropType<IWorkflowState>,
      required: true
    },
    readonly: {
      type: Boolean
    }
  },

  setup(props, { emit }) {
    const {
      fitView,
      findEdge,
      findNode,
      removeEdges,
      removeNodes,
      getConnectedEdges
    } = useWorkFlow();

    const connections = useNodeConnections({
      nodeId: computed(() => props.state.id!.toString())
    });

    const stateConnections = computed(() =>
      connections.value.map(connection => {
        return {
          transition: findEdge<IWorkflowTransition>(connection.edgeId)?.data,
          sourceState: findNode<IWorkflowState>(connection.source)?.data
        };
      })
    );

    const store = useStore<IRootState>();

    const { useActions } = createNamespacedHelpers<
      IWorkflowStoreState,
      IWorkflowGetters,
      IWorkflowActions,
      IWorkflowMutations
    >(store, 'workflow');

    const { deleteWorkflowState } = useActions(['deleteWorkflowState']);

    const error = ref<ISystemError | null>(null);

    function clearErrors() {
      error.value = null;
    }

    const stateDeleteInProgress = ref(false);

    const deleteStateDialog = ref(false);

    function cancelStateDeleteDialog() {
      deleteStateDialog.value = false;
    }

    async function removeState() {
      const stateId = props.state.id!;

      const transitions = getConnectedEdges<IWorkflowTransition>(
        stateId.toString()
      ).map(edge => edge.data);

      try {
        stateDeleteInProgress.value = true;
        await deleteWorkflowState({
          workflowId: props.workflowId!,
          stateId: stateId!
        });

        removeEdges(transitions.map(transition => transition.id!.toString()));
        removeNodes(stateId.toString(), true);

        emit('deleted-state', stateId, transitions);
        deleteStateDialog.value = false;
      } catch (err) {
        error.value = setErrorFromAxiosError(err as AxiosError);
      } finally {
        stateDeleteInProgress.value = false;
      }
    }

    function centerStateOnCanvas() {
      fitView({ nodes: [String(props.state.id)], duration: 280 }).then(() => {
        emit('center-state-on-canvas');
      });
    }

    const isDisplayingConnections = ref(false);

    return {
      error,
      deleteStateDialog,
      stateDeleteInProgress,

      cancelStateDeleteDialog,
      removeState,
      clearErrors,
      centerStateOnCanvas,

      stateConnections,
      isDisplayingConnections,

      hexToRGB: HexToRGB
    };
  }
});
